module.exports = __webpack_public_path__ + "static/media/educating-girls-symposium-logo-2021-yellow.0e43d397.png";